import { Portal } from 'bringg-web/components';
import { TemplatesManagerWithRoot } from 'bringg-web/features/templates-manager';

const TemplatesPortal = () => {
	return <Portal element={<TemplatesManagerWithRoot />} nodeId="templates-page" />;
};

export default TemplatesPortal;
